import { useNuxtApp } from 'nuxt/app';
import { useContentMenusStore } from '~~/common/stores/contentMenus';

/**
 * Petrol breadcrumb helpers shared across the petrol pages and AwPetrolMenu.
 * Centralises the "petrol home" breadcrumb element (its i18n token and the
 * petrol landing link) so the trail is built consistently everywhere.
 */
export function usePetrolBreadcrumbs () {
  const { $awt } = useNuxtApp();
  const contentMenusStore = useContentMenusStore();

  function petrolHomeBreadcrumb (disabled: boolean) {
    const to = contentMenusStore.petrolHomeLink;
    return {
      token: $awt('aw.pages.petrol.title'),
      to,
      // Without a CMS landing there is nowhere to navigate, so the level stays
      // visible but is rendered as plain text rather than a dead link.
      disabled: disabled || !to,
    };
  }

  return { petrolHomeBreadcrumb };
}
